import {  Inject, Injectable } from '@angular/core';
import { WindowsWrapper } from '../../app.config';
import { WebStorageService } from './webstorage.service';
import { AppService } from '@app/_core/services/app.service';
import { environment } from '@environments/environment';
@Injectable({
  providedIn: 'root'
})
export class WindowsWrapperService {
    loginParams: any;
    company: string;
    debugMode: boolean = false; 
    constructor(@Inject(WindowsWrapper) private _Wrapper: any,
        private webStorageService: WebStorageService,
        private appService: AppService,
    ) {
        this.loginParams = this.webStorageService.getItemFromSessionStorage('loginParams');
        this.company = this.webStorageService.getItemFromSessionStorage('company');
        this.debugMode = (environment.environmentName !== 'PROD'); 
    } 
    IsWrapper() {
        let isValid = this._Wrapper.IsWrapper; 
        //if (isValid) this._Wrapper.OnvidaWrapper.setWebApiHost(environment.apiUrl);
        return isValid;
    }
    SendPreferences(isRecord: any): void {        
        if (this.IsWrapper()) { 
            let loginParams = this.webStorageService.getItemFromSessionStorage('company');
            this.company = loginParams;
            if(this.company){
                let appParams = loginParams;
                this.debug('SendPreferences',appParams);
                let RecordAgentScreen = (isRecord == null ? this.appService.getRecordingAgentScreen() : isRecord);
                this._Wrapper.OnvidaWrapper.sendPreferences(appParams.BlockCopy, appParams.BlockScreenCapture, RecordAgentScreen, appParams.UserID, appParams.UserName, this.company);
            }
            
        }
    }
    StartVideoRecording(): void { 
        if (this.IsWrapper()) {
            this.debug('StartVideoRecording');
            this._Wrapper.OnvidaWrapper.startRecording(); 
        }
    }
    SaveVideoRecording(interactionId:number): void { 
        if (this.IsWrapper()) {
            this.debug('SaveVideoRecording - ' + interactionId);
            this._Wrapper.OnvidaWrapper.saveVideoRecording(interactionId); 
        }
    }
    StopVideoRecording(): void { 
        if (this.IsWrapper()) {
            this.debug('StopVideoRecording');
            this._Wrapper.OnvidaWrapper.discardVideo(); 
        }
    } 
    debug(msg: string, obj?: any) {
        if (this.debugMode) { 
            console.log(msg, obj);
        }
    } 
    EnableCRProtocol(isEnable: boolean): void { 
        this._Wrapper.OnvidaWrapper.enableIEProtocol(isEnable); 
    }

    WebApiUrl(url: string): void {
        try {
            this._Wrapper.OnvidaWrapper.webAPIUrl(url);
        } catch (error) {
            this.debug('Not Found WebApiUrl method in wrapper');
        }
    }
}
